import React from 'react';
import { Helmet } from 'react-helmet-async';

const SeoHelmets = ({ title, description, keywords, image, url }) => {
    const defaultTitle = "Insight IAS Academy - Best Coaching for UPSC/IAS";
    const defaultDescription = "Insight IAS Academy provides the best coaching for UPSC, IAS, CUET, NEET, and UGC NET exams in Delhi.";
    
    return (
        <Helmet>
            {/* SEO Meta Tags */}
            <title>{title ? `${title} | Insight IAS` : defaultTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={url || window.location.href} />

            {/* Open Graph Tags */}
            <meta property="og:title" content={title || defaultTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            {image && <meta property="og:image" content={image} />}
            {url && <meta property="og:url" content={url} />}
            <meta property="og:type" content="website" />

            {/* Twitter Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title || defaultTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            {image && <meta name="twitter:image" content={image} />}
        </Helmet>
    );
}

export default SeoHelmets;
